export default __webpack_public_path__ + "static/media/edit_white.0e479b50.svg";